import { useEffect } from "react";
import { setDefaultLocale } from "react-datepicker";
import { I18nextProvider } from "react-i18next";
import { Route, Routes } from "react-router-dom";
import NavBar from "./components/navigation/NavBar/NavBar";
import PublicNavBar from "./components/navigation/PublicNavBar/PublicNavBar";
import ProtectedRoute from "./components/routing/ProtectedRoute/ProtectedRoute";
import i18n from "./lang/i18n";

import Login from "./pages/Auth/Login";
import Registration from "./pages/Auth/Registration/Registration";
import ResetPassword from "./pages/Auth/ResetPassword/ResetPassword";
import NotFound from "./pages/NotFound/NotFound";
import MyTeam from "./pages/MyTeam/MyTeam";
import Regions from "./pages/Admin/Regions";
import Teams from "./pages/Admin/Teams";
import ExamCenters from "./pages/Admin/ExamCenters";
import Classrooms from "./pages/Admin/Classrooms";
import SendMail from "./pages/Admin/SendMail";
import { UserContext } from "./utils/contexts/UserContext";
import useFindUser from "./utils/hooks/useFindUser";
import StudentNavBar from "./components/navigation/StudentNavBar/StudentNavBar";

import "react-toastify/dist/ReactToastify.css";
import { ToastContainer } from "react-toastify";
import Index from "./pages/Index/Index";
import Accounts from "./pages/Admin/Accounts";
import Results from "./pages/Admin/Results";
import UploadResults from "./pages/Admin/Results/Upload";
import NewUploadResults from "./pages/Admin/Results/ResultsAdmin/UploadResultsAdmin/NewUploadResults";

function App() {
  const { user, setUser, isLoading } = useFindUser();

  useEffect(() => {
    // setDefaultLocale(localStorage.getItem("i18nextLng"));
    setDefaultLocale("kk");
    localStorage.setItem("i18nextLng", "kk");

    return () => {};
  }, []);

  return (
    <I18nextProvider i18n={i18n}>
      <UserContext.Provider value={{ user, setUser, isLoading }}>
        <ToastContainer position="top-center" />
        <Routes>
          {/* Public part */}
          {/* <Route index element={<Login />} /> */}
          <Route index element={<Index />} />
          {/* <Route index element={<Login />} /> */}

          <Route
            element={
              <ProtectedRoute
                redirectPath={
                  user?.roles?.some((role) =>
                    ["ADMIN", "EXAM_CENTER_ADMIN"].includes(role?.code)
                  )
                    ? "/admin/teams"
                    : "/my-team"
                }
                isAllowed={!user?.uuid}
              />
            }
          >
            <Route element={<PublicNavBar />}>
              <Route path="/login" element={<Login />} />
              <Route path="/registration" element={<Registration />} />
              <Route path="/password-reset/" element={<ResetPassword />} />
            </Route>
          </Route>

          {/* My Team - Protected route */}

          {/* Private part */}
          {/* Admin side */}
          <Route
            element={
              <ProtectedRoute
                // redirectPath="/applicants"
                isAllowed={
                  !!user?.uuid &&
                  user?.roles?.some((role) =>
                    ["ADMIN", "EXAM_CENTER_ADMIN"].includes(role?.code)
                  )
                }
                isLoading={isLoading}
              />
            }
          >
            <Route path="/" element={<NavBar user={user} setUser={setUser} />}>
              <Route path="/admin/teams" element={<Teams />} />
              <Route path="/admin/classrooms" element={<Classrooms />} />
              <Route path="/admin/results" element={<Results />} />
              <Route path="/admin/results/upload" element={<UploadResults />} />
              <Route
                element={
                  <ProtectedRoute
                    redirectPath="/admin/teams"
                    isAllowed={
                      !!user?.uuid &&
                      user?.roles?.some((role) => role?.code === "ADMIN")
                    }
                    isLoading={isLoading}
                  />
                }
              >
                <Route path="/admin/regions" element={<Regions />} />
                <Route
                  path="/admin/results/files"
                  element={<NewUploadResults />}
                />
                <Route path="/admin/exam-centers" element={<ExamCenters />} />
                <Route path="/admin/send-mail" element={<SendMail />} />
                <Route path="/admin/accounts" element={<Accounts />} />
              </Route>
            </Route>
          </Route>

          {/* Student side */}
          <Route
            element={
              <ProtectedRoute isAllowed={!!user?.uuid} isLoading={isLoading} />
            }
          >
            <Route
              path="/"
              element={<StudentNavBar user={user} setUser={setUser} />}
            >
              <Route
                element={
                  <ProtectedRoute
                    isAllowed={!!user?.uuid}
                    isLoading={isLoading}
                  />
                }
              >
                <Route path="/my-team" element={<MyTeam />} />
              </Route>
            </Route>
          </Route>
          <Route path="*" element={<NotFound />} />
        </Routes>
      </UserContext.Provider>
    </I18nextProvider>
  );
}

export default App;
